





























import Vue from 'vue';
import { DocumentDetailForm } from '@/components/my-documents-components/document-detail-form-component';
import { CloseFullscreenWrapper, FormValidation } from '@/mixins';
import { FullscreenWrapper } from '@/components/fullscreen-wrapper-components';
import { ExtendMixins } from '@/services';

interface Data {
  confirmBeforeClose: boolean;
  changeMade: boolean;
  submitIsLoading: boolean;
  showSubmitSuccessMessage: boolean;
  successMessage: string;
  showSubmitErrorMessage: boolean;
  errorMessage: string;
  document: any;
}

export default ExtendMixins(
  CloseFullscreenWrapper,
  FormValidation,
).extend({
  name: 'UpdateDocumentDetail',
  props: {
    params: {
      type: Object as () => any,
      required: true,
    },
  },
  data(): Data {
    return {
      confirmBeforeClose: true,
      changeMade: false,
      submitIsLoading: false,
      showSubmitSuccessMessage: false,
      successMessage: this.params.successMessage,
      showSubmitErrorMessage: false,
      errorMessage: this.params.errorMessage,
      document: this.params.document,
    };
  },
  methods: {
    updateConfirmBeforeClose(val): void {
      this.confirmBeforeClose = val;
    },
    toggleLoading(val): void {
      this.submitIsLoading = val;
    },
  },
  components: {
    DocumentDetailForm,
    FullscreenWrapper,
  },
});
